import React, {useEffect} from 'react';
import {InitData, Poi} from '../react-app-env';
import bundledInitData from '../initdata.json';
import {Events, EventType} from '../events/Events';

const tripId = globalThis.location.hash?.replace('#', '');
let initData: InitData | null = null;

if (tripId != null && tripId !== '') {
  const dataSource = `https://fernrausch.com/shared/${tripId}`;
  const response = await fetch(dataSource);
  const html = await response.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const initDataElement = doc.querySelector('#frinit');
  initData = JSON.parse(initDataElement?.textContent!) as InitData;
}

export function useModel(onModelAvailable?: (model: InitData) => void) {
  const [model, setModel] = React.useState<InitData>();

  // Initialise component

  useEffect(() => {
    if (initData) {
      if (document.location.hostname === 'localhost') {
        initData.googleMapsApiKey = bundledInitData.googleMapsApiKey;
      }
      setModel(initData);
      onModelAvailable?.(initData);
    }

    const eventSubscriptions = Events.collect();
    eventSubscriptions.subscribe(EventType.ON_POI_UPDATED, (updatedPoi: Poi) => onPoiUpdated(updatedPoi));

    return () => eventSubscriptions.cancel();
  }, []);

  // Private implementation

  function onPoiUpdated(updatedPoi: Poi) {
    setModel(prev => {
      return prev && {
        ...prev,
        trip: {
          ...prev.trip,
          pois: prev.trip.pois.map(poi => poi.id === updatedPoi.id ? updatedPoi : poi)
        }
      }
    });
  }

  // Rendering

  return model;
}
